import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

/**
 * Single Cinematic Eternity Logo Intro
 * 1.8 seconds → auto-transitions to feed
 * Uses OFFICIAL Eternity logo symbol
 */
export default function EternityLogoIntro({ onComplete }) {
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsComplete(true);
      if (onComplete) onComplete();
    }, 1800);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div
      data-testid="cinematic-intro-container"
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#0A0A0F] overflow-hidden"
      initial={{ opacity: 1 }}
      animate={{ opacity: isComplete ? 0 : 1 }}
      transition={{ duration: 0.5, delay: isComplete ? 0 : 0 }}
      style={{ pointerEvents: isComplete ? 'none' : 'auto' }}
    >
      {/* Atmospheric Particle Haze */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0 bg-gradient-radial from-[#FF6B35]/10 via-transparent to-transparent" />
      </div>

      {/* OFFICIAL Eternity Logo Symbol */}
      <motion.div
        className="relative"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }}
      >
        <motion.img
          src="/logos/eternity-symbol.png"
          alt="Eternity"
          className="w-48 h-48 object-contain"
          style={{ filter: 'brightness(0) invert(1)' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
        />

        {/* Ember Edge Shimmer */}
        <motion.div
          className="absolute inset-0 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(255,107,53,0.25) 0%, transparent 70%)',
            filter: 'blur(50px)'
          }}
          animate={{
            scale: [1, 1.15, 1],
            opacity: [0.2, 0.4, 0.2]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </motion.div>

      {/* Light Sweep */}
      <motion.div
        className="absolute inset-0"
        initial={{ x: '-100%', opacity: 0 }}
        animate={{ x: '100%', opacity: [0, 0.3, 0] }}
        transition={{
          duration: 1.5,
          delay: 0.4,
          ease: "easeInOut"
        }}
        style={{
          background: 'linear-gradient(90deg, transparent, rgba(255,107,53,0.12), transparent)',
          width: '150%'
        }}
      />
    </motion.div>
  );
}
